<header class="sticky top-0 z-40 bg-white shadow-sm">
  <!-- Thanh thông tin trên cùng -->
  <div
    class="hidden border-b border-slate-200 bg-slate-50 text-xs text-slate-600 md:block"
  >
    <div
      class="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-1.5"
    >
      <p class="flex min-w-0 items-center gap-1.5">
        <mat-icon
          class="!h-3.5 !w-3.5 shrink-0 text-emerald-600"
          svgIcon="hero:place"
        ></mat-icon>
        <span class="truncate">{{ site().contact.address }}</span>
      </p>
      <div class="flex shrink-0 items-center gap-4">
        <span class="hidden items-center gap-1.5 lg:inline-flex">
          <mat-icon
            class="!h-3.5 !w-3.5 text-emerald-600"
            svgIcon="hero:schedule"
          ></mat-icon>
          {{ site().contact.workingHours }}
        </span>
        <a
          [href]="'tel:' + site().contact.phone"
          class="inline-flex items-center gap-1.5 font-semibold text-slate-800 hover:text-emerald-700"
        >
          <mat-icon
            class="!h-3.5 !w-3.5 text-emerald-600"
            svgIcon="hero:phone"
          ></mat-icon>
          {{ site().contact.phoneLabel }}: {{ site().contact.phoneDisplay }}
        </a>
      </div>
    </div>
  </div>

  <!-- Hàng chính: logo, tìm kiếm, tài khoản -->
  <div
    data-desktop-header
    class="mx-auto hidden max-w-7xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 md:flex md:flex-nowrap"
  >
    <a
      routerLink="/"
      class="flex shrink-0 items-center gap-2"
      [attr.aria-label]="site().brand.name + ' - Trang chủ'"
    >
      <img
        src="assets/Green_Energy_Mobility_Logo-removebg-preview.png"
        alt=""
        class="h-10 w-10 object-contain"
      />
      <span class="block">
        <span class="block text-lg font-bold leading-none text-slate-900">{{
          site().brand.name
        }}</span>
        <span
          class="mt-1 hidden text-[11px] leading-none text-slate-500 sm:block"
          >{{ site().brand.tagline }}</span
        >
      </span>
    </a>

    <form
      role="search"
      class="order-last flex w-full min-w-0 overflow-hidden rounded-md border border-slate-300 focus-within:border-emerald-600 md:order-none md:mx-4 md:w-auto md:flex-1"
      (submit)="onSearch($event)"
    >
      <label class="sr-only" for="cm-search-kind">Ngành hàng</label>

      <label class="sr-only" for="cm-search-input">Tìm kiếm sản phẩm</label>
      <input
        id="cm-search-input"
        type="search"
        name="q"
        autocomplete="off"
        placeholder="Tìm kiếm sản phẩm..."
        class="min-w-0 flex-1 border-0 px-3 py-2 text-sm text-slate-800 placeholder:text-slate-500 focus:outline-none"
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)"
      />
      <button
        type="submit"
        class="inline-flex shrink-0 items-center gap-1 bg-emerald-700 px-4 text-sm font-semibold text-white hover:bg-emerald-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white"
        aria-label="Tìm kiếm"
      >
        <mat-icon svgIcon="hero:search"></mat-icon>
        <span class="hidden lg:inline">Tìm kiếm</span>
      </button>
    </form>
  </div>

  <!-- Hàng chính: logo, tìm kiếm, tài khoản -->
  <div
    class="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-6 gap-y-3 px-4 py-3 md:hidden"
  >
    <!-- Logo -->
    <a
      routerLink="/"
      class="flex shrink-0 items-center gap-2"
      [attr.aria-label]="site().brand.name + ' - Trang chủ'"
    >
      <img
        src="assets/Green_Energy_Mobility_Logo-removebg-preview.png"
        alt=""
        class="h-10 w-10 object-contain"
      />

      <span class="block">
        <span class="block text-lg font-bold leading-none text-slate-900">
          {{ site().brand.name }}
        </span>

        <span
          class="mt-1 hidden text-[11px] leading-none text-slate-500 sm:block"
        >
          {{ site().brand.tagline }}
        </span>
      </span>
    </a>

    <!-- Search -->
    <form
      role="search"
      class="order-last flex h-10 min-w-0 w-120 overflow-hidden rounded-lg border border-slate-300 bg-white transition focus-within:border-emerald-600 focus-within:ring-2 focus-within:ring-emerald-100 md:order-none md:mx-4 md:max-w-3xl"
      (submit)="onSearch($event)"
    >
      <label class="sr-only" for="cm-mobile-search-input">
        Tìm kiếm sản phẩm
      </label>

      <input
        id="cm-mobile-search-input"
        type="search"
        name="q"
        autocomplete="off"
        placeholder="Tìm kiếm sản phẩm..."
        class="min-w-0 flex-1 border-0 bg-transparent p-2 text-sm text-slate-800 outline-none placeholder:text-slate-400 focus:ring-0"
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)"
      />

      <button
        type="submit"
        class="inline-flex shrink-0 items-center gap-2 bg-emerald-700 px-5 text-sm font-semibold text-white transition hover:bg-emerald-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white"
        aria-label="Tìm kiếm"
      >
        <mat-icon class="!text-[20px]" svgIcon="hero:search"></mat-icon>
        <span class="hidden sm:inline">Tìm kiếm</span>
      </button>
    </form>
  </div>

  <!-- Thanh danh mục -->
  <div class="hidden bg-emerald-700 md:block">
    <nav
      class="mx-auto hidden max-w-7xl items-center px-4 md:flex"
      aria-label="Điều hướng chính"
    >
      @for (item of navItems; track item.path) {
        @if (item.kind && hasMenu(item.kind)) {
          @let k = item.kind;
          <div
            #group
            class="relative"
            (pointerenter)="onPointerEnter($event, k)"
            (pointerleave)="onPointerLeave($event)"
            (keydown.escape)="onEscape(k)"
            (focusout)="onFocusOut($event, group)"
          >
            <div
              class="flex items-center text-white transition-colors hover:bg-emerald-800"
              [ngClass]="isActive(item) ? 'bg-emerald-800' : ''"
            >
              <a
                [routerLink]="item.path"
                class="py-3 pl-4 pr-1 text-sm font-semibold uppercase"
                [attr.aria-current]="isActive(item) ? 'page' : null"
                (click)="closeNow()"
              >
                {{ item.label }}
              </a>
              <button
                type="button"
                [id]="'cm-nav-btn-' + k"
                class="mr-1 inline-flex h-8 w-8 items-center justify-center rounded-md"
                aria-haspopup="menu"
                [attr.aria-expanded]="openKind() === k"
                [attr.aria-controls]="'cm-nav-panel-' + k"
                [attr.aria-label]="'Danh mục ' + item.label"
                (click)="toggleDropdown(k)"
                (keydown)="onTriggerKeydown($event, k)"
              >
                <mat-icon
                  class="!h-4 !w-4 transition-transform"
                  [class.rotate-180]="openKind() === k"
                  svgIcon="hero:expand_more"
                ></mat-icon>
              </button>
            </div>

            @if (openKind() === k) {
              <div class="absolute left-0 top-full z-50">
                <div
                  [id]="'cm-nav-panel-' + k"
                  role="menu"
                  [attr.aria-label]="item.label"
                  class="max-h-[70vh] w-64 overflow-y-auto rounded-b-md border border-slate-200 bg-white py-1 shadow-md"
                  (keydown)="onPanelKeydown($event, k)"
                >
                  @for (root of rootsByKind()[k]; track root.id) {
                    <a
                      role="menuitem"
                      [routerLink]="item.path"
                      [queryParams]="{ category: root.slug, focus: 'catalog' }"
                      class="block px-4 py-2 text-sm font-semibold text-slate-800 hover:bg-slate-50 hover:text-emerald-700 focus:bg-slate-50 focus:outline-none"
                      (click)="closeNow()"
                    >
                      {{ root.name }}
                    </a>
                    @for (child of root.children; track child.id) {
                      <a
                        role="menuitem"
                        [routerLink]="item.path"
                        [queryParams]="{
                          category: child.slug,
                          focus: 'catalog',
                        }"
                        class="block py-1.5 pl-8 pr-4 text-[13px] text-slate-600 hover:bg-slate-50 hover:text-emerald-700 focus:bg-slate-50 focus:outline-none"
                        (click)="closeNow()"
                      >
                        {{ child.name }}
                      </a>
                    }
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <a
            [routerLink]="item.path"
            class="px-4 py-3 text-sm font-semibold uppercase text-white transition-colors hover:bg-emerald-800"
            [ngClass]="isActive(item) ? 'bg-emerald-800' : ''"
            [attr.aria-current]="isActive(item) ? 'page' : null"
          >
            {{ item.label }}
          </a>
        }
      }
      <a
        href="/#product-lookup"
        class="px-4 py-3 text-sm font-semibold uppercase text-white transition-colors hover:bg-emerald-800"
        (click)="$event.preventDefault(); navigateToProductLookup()"
      >
        Kiểm tra bảo hành
      </a>
    </nav>
  </div>

  @if (menuOpen()) {
    <nav
      id="cm-mobile-menu"
      class="max-h-[calc(100vh-8rem)] overflow-y-auto border-t border-slate-200 bg-white px-4 pb-4 pt-2 md:hidden"
      aria-label="Điều hướng di động"
    >
      <ul class="flex flex-col divide-y divide-slate-100">
        @for (item of navItems; track item.path) {
          <li>
            @if (item.kind && hasMenu(item.kind)) {
              @let k = item.kind;
              <div
                class="flex items-center"
                [ngClass]="
                  isActive(item) ? 'text-emerald-700' : 'text-slate-800'
                "
              >
                <a
                  [routerLink]="item.path"
                  class="block min-w-0 flex-1 py-3 text-sm font-semibold uppercase"
                  [attr.aria-current]="isActive(item) ? 'page' : null"
                >
                  {{ item.label }}
                </a>
                <button
                  type="button"
                  class="inline-flex h-10 w-10 items-center justify-center rounded-md"
                  [attr.aria-expanded]="mobileKind() === k"
                  [attr.aria-controls]="'cm-mobile-sub-' + k"
                  [attr.aria-label]="'Danh mục ' + item.label"
                  (click)="toggleMobile(k)"
                >
                  <mat-icon
                    class="transition-transform"
                    [class.rotate-180]="mobileKind() === k"
                    svgIcon="hero:expand_more"
                  ></mat-icon>
                </button>
              </div>
              @if (mobileKind() === k) {
                <ul
                  [id]="'cm-mobile-sub-' + k"
                  class="mb-2 ml-2 border-l-2 border-emerald-600 pl-2"
                >
                  @for (root of rootsByKind()[k]; track root.id) {
                    <li>
                      <a
                        [routerLink]="item.path"
                        [queryParams]="{
                          category: root.slug,
                          focus: 'catalog',
                        }"
                        class="block px-3 py-2 text-sm font-semibold text-slate-800 hover:text-emerald-700"
                      >
                        {{ root.name }}
                      </a>
                      @if (root.children?.length) {
                        <ul>
                          @for (child of root.children; track child.id) {
                            <li>
                              <a
                                [routerLink]="item.path"
                                [queryParams]="{
                                  category: child.slug,
                                  focus: 'catalog',
                                }"
                                class="block py-1.5 pl-7 pr-3 text-[13px] text-slate-600 hover:text-emerald-700"
                              >
                                {{ child.name }}
                              </a>
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              }
            } @else {
              <a
                [routerLink]="item.path"
                class="block py-3 text-sm font-semibold uppercase"
                [ngClass]="
                  isActive(item) ? 'text-emerald-700' : 'text-slate-800'
                "
                [attr.aria-current]="isActive(item) ? 'page' : null"
              >
                {{ item.label }}
              </a>
            }
          </li>
        }
        <li>
          <a
            href="/#product-lookup"
            class="block py-3 text-sm font-semibold uppercase text-slate-800"
            (click)="$event.preventDefault(); navigateToProductLookup()"
          >
            Kiểm tra bảo hành
          </a>
        </li>
        @if (accountService.isBackOffice()) {
          <li>
            <a
              routerLink="/admin"
              class="block py-3 text-sm font-semibold text-slate-800"
              >Quản trị</a
            >
          </li>
        }
        <li class="flex flex-col gap-2 pt-3">
          @if (accountService.currentUser()) {
            <button
              type="button"
              class="btn-outline w-full"
              (click)="accountService.logout()"
            >
              Đăng xuất
            </button>
          } @else {
            <a routerLink="/account/login" class="btn-primary w-full"
              >Đăng nhập</a
            >
          }
          <a [href]="'tel:' + site().contact.phone" class="btn-outline w-full">
            <mat-icon
              class="!h-4 !w-4 text-emerald-600"
              svgIcon="hero:phone"
            ></mat-icon>
            {{ site().contact.phoneLabel }} {{ site().contact.phoneDisplay }}
          </a>
        </li>
      </ul>
    </nav>
  }
</header>
